import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18RightcircleG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      transform: "translate(1 1)",
      children: [/*#__PURE__*/jsx("circle", {
        cx: 8,
        cy: 8,
        r: 8,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        transform: "rotate(-90 8 8)"
      }), /*#__PURE__*/jsx("circle", {
        cx: 8,
        cy: 8,
        r: 8,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        transform: "rotate(-90 8 8)"
      }), /*#__PURE__*/jsx("circle", {
        cx: 8,
        cy: 8,
        r: 8,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey100,
        transform: "rotate(-90 8 8)"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        d: "M6.615 4.705a.544.544 0 0 0-.053.71l.052.06 2.524 2.53-2.523 2.52a.544.544 0 0 0-.053.71l.052.06a.544.544 0 0 0 .71.053l.062-.052 2.909-2.905a.544.544 0 0 0 .053-.71l-.052-.06-2.911-2.916a.544.544 0 0 0-.77 0"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18RightcircleG$1 = Svg18RightcircleG;

export { Svg18RightcircleG$1 as default };
